import React from 'react';
import en from '../../lang/en-us';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const { dashboard } = en;

interface CheckBoxFieldProps {
    label?: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    value?: boolean;
    disabled?: boolean;
    setSize?: number;
    posInSet?: number;
}

const useStyles = makeStyles({
    checkbox: {
        color: '#1B5E20',

        '&.Mui-checked': {
            color: '#1B5E20',
        },
        '&.Mui-checked .MuiIconButton-label': {
            color: '#1B5E20',
        },
        '& .MuiSvgIcon-root': {
            fill: '#1B5E20',
        },

        /* mouse hover - subtle background only, no outline */
        '&:hover': {
            backgroundColor: 'rgba(27, 94, 32, 0.08)',
        },

        /* keyboard focus (tab navigation) - show outline */
        '&.Mui-focusVisible': {
            backgroundColor: 'rgba(27, 94, 32, 0.18)',
            outline: '3px solid #1B5E20',
            outlineOffset: '3px',
            borderRadius: 4,
        },

        /* keep hover darker when checked */
        '&.Mui-checked:hover': {
            backgroundColor: 'rgba(27, 94, 32, 0.12)',
        },

        /* keep focus darker when checked */
        '&.Mui-checked.Mui-focusVisible': {
            backgroundColor: 'rgba(27, 94, 32, 0.22)',
            outline: '3px solid #1B5E20',
            outlineOffset: '3px',
            borderRadius: 4,
        },
    },
});

export function CheckBoxField({
    label = '',
    onChange = () => { },
    value = false,
    disabled = false,
    setSize,
    posInSet,
}: CheckBoxFieldProps) {
    const classes = useStyles();

    const baseLabel = label || 'checkbox';
    const positionSuffix =
        typeof setSize === 'number' && typeof posInSet === 'number'
            ? `, ${posInSet} of ${setSize}`
            : '';
    const inputProps: Record<string, any> = {
        'aria-label': `${baseLabel}${positionSuffix}`,
    };

    return (
        <FormControlLabel
            label={label}
            disabled={disabled}
            control={
                <Checkbox
                    className={classes.checkbox}
                    onChange={onChange}
                    checked={value}
                    disabled={disabled}
                    disableRipple={true}
                    disableTouchRipple={true}
                    inputProps={inputProps}
                />
            }
        />
    );
}
